import { render, staticRenderFns } from "./FacilityManagementHospital.vue?vue&type=template&id=9f8d02ca&scoped=true"
import script from "./FacilityManagementHospital.vue?vue&type=script&lang=ts"
export * from "./FacilityManagementHospital.vue?vue&type=script&lang=ts"
import style0 from "./FacilityManagementHospital.vue?vue&type=style&index=0&id=9f8d02ca&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8d02ca",
  null
  
)

export default component.exports